import * as AlertBarState from '../../components/alert-bar/AlertBar.state';
import * as ModalState from '../../components/modal/Modal.state';
import { logout } from '../../state/reducer';
import * as Nested from '../../utils/Nested';
import { CloseoutForm } from './CloseoutForm';
import { replaceAlerts } from '../../components/alert-bar/AlertBar.state';

// Alert Bar Nested Actions
export const CLOSEOUT_ALERT_BAR_ACTION = 'closeout/CLOSEOUT_ALERT_BAR_ACTION';
export const closeoutAlertBarAction = Nested.nestedAction(
  CLOSEOUT_ALERT_BAR_ACTION,
);

// Modal Nested Actions
export const MODAL_ACTION = 'closeout/MODAL_ACTION';
export const closeoutModalAction = Nested.nestedAction(MODAL_ACTION);

// Action Creators and Action Types
export const CLOSEOUT_FORM_ACTION = 'closeout/CLOSEOUT_FORM_ACTION';
export const closeoutFormAction = Nested.nestedAction(CLOSEOUT_FORM_ACTION);

export const SUBMIT_CLOSEOUT_FORM = 'closeout/SUBMIT_CLOSEOUT_FORM';
export const submitCloseoutForm = (payload) => ({
  type: SUBMIT_CLOSEOUT_FORM,
  payload,
});

export const FETCH_CURRENT_BATCH_REQUEST =
  'closeout/FETCH_CURRENT_BATCH_REQUEST';
export const fetchCurrentBatch = (payload) => ({
  type: FETCH_CURRENT_BATCH_REQUEST,
  payload,
});
export const FETCH_CURRENT_BATCH_SUCCESS =
  'closeout/FETCH_CURRENT_BATCH_SUCCESS';
export const fetchCurrentBatchSuccess = (payload) => ({
  type: FETCH_CURRENT_BATCH_SUCCESS,
  payload,
});
export const CREATE_CLOSEOUT_SUCCESS = 'closeout/CREATE_CLOSEOUT_SUCCESS';
export const createCloseoutSuccess = (payload) => ({
  type: CREATE_CLOSEOUT_SUCCESS,
  payload,
});
export const FETCH_CLOSEOUT_REPORT_REQUEST =
  'closeout/FETCH_CLOSEOUT_REPORT_REQUEST';
export const fetchCloseoutReportRequest = (payload) => ({
  type: FETCH_CLOSEOUT_REPORT_REQUEST,
  payload,
});
export const FETCH_CLOSEOUT_REPORT_SUCCESS =
  'closeout/FETCH_CLOSEOUT_REPORT_SUCCESS';
export const fetchCloseoutReportSuccess = (payload) => ({
  type: FETCH_CLOSEOUT_REPORT_SUCCESS,
  payload,
});

// Default State
const initialState = {
  data: {
    batch: {
      id: '',
      float: '0.00',
      total_cash: '0.00',
      total_check: '0.00',
      total_card: '0.00',
      total_wire_payment: '0.00',
    },
    reports: {},
  },
  error: false,
  isLoading: false,
};
// Raw Reducer
export const _reducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case SUBMIT_CLOSEOUT_FORM:
      return {
        ...state,
        isLoading: true,
      };
    case FETCH_CURRENT_BATCH_SUCCESS:
      return {
        ...state,
        data: {
          ...state.data,
          batch: {
            ...payload,
          },
        },
      };
    case FETCH_CLOSEOUT_REPORT_SUCCESS:
      return {
        ...state,
        isLoading: false,
        data: {
          ...state.data,
          reports: payload.reports,
        },
      };
    case CREATE_CLOSEOUT_SUCCESS:
    default:
      return state;
  }
};

const cartAlertMessage = {
  heading: 'Closeout Page Error',
  text: "Can't closeout with items in cart.",
  variant: 'error',
};

// Raw Redux Maps
export const _mapStateToProps = () => {
  /* 
  this piece of the state tree has been refactored to use useSelector instead, 
  but the Nested states pattern forces this function to exist so the forms, alertBars, and modals can be passed in.
  */
};

export const _mapDispatchToProps = (dispatch) => ({
  submitCloseoutForm: (payload) => dispatch(submitCloseoutForm(payload)),
  fetchCurrentBatch: () => dispatch(fetchCurrentBatch()),
  logout: (navigate) => dispatch(logout(navigate)),
  displayCartAlert: () =>
    dispatch(closeoutAlertBarAction(replaceAlerts(cartAlertMessage))),
});

// Nested Redux Maps
const {
  reducer: nestedReducer,
  mapStateToProps,
  mapDispatchToProps,
  actions,
} = Nested.nestStates(
  {
    reducer: _reducer,
    mapStateToProps: _mapStateToProps,
    mapDispatchToProps: _mapDispatchToProps,
  },
  {
    forms: {
      closeoutForm: {
        ...CloseoutForm,
        actionType: CLOSEOUT_FORM_ACTION,
      },
    },
    alertBars: {
      closeoutAlertBars: {
        ...AlertBarState,
        actionType: CLOSEOUT_ALERT_BAR_ACTION,
      },
    },
    modals: {
      closeout: {
        ...ModalState,
        actionType: MODAL_ACTION,
      },
    },
  },
  'closeout',
);

// Nested Reducer
const reducer = (state, action) => nestedReducer(state, action);

export { reducer, mapStateToProps, mapDispatchToProps, actions };
